module.exports = __webpack_public_path__ + "img/logo.3e4aa2d4.png";